import createReactComponent from '../createReactComponent';
export default createReactComponent('steering-wheel', 'IconSteeringWheel', [
  ['path', { d: 'M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', key: 'svg-0' }],
  ['path', { d: 'M12 12m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0', key: 'svg-1' }],
  ['path', { d: 'M12 14l0 7', key: 'svg-2' }],
  ['path', { d: 'M10 12l-6.75 -2', key: 'svg-3' }],
  ['path', { d: 'M14 12l6.75 -2', key: 'svg-4' }],
]);
